import { parseFaqAccordion } from './components/FaqAccordion/FaqAccordion.parser';
import { FaqV2Props } from './FaqV2';

// TODO Update contentfulSection type
export const parseFaqV2Data = (contentfulSection: any): FaqV2Props | null => {
  const {
    displayName,
    subsections,
    metadata: { title },
  } = contentfulSection;

  // Validate that all sections are added in Contentful
  if (!displayName && !subsections && !title) {
    return null;
  }

  const faqs = parseFaqAccordion(subsections).faqs;

  const FaqV2Props = {
    eyebrow: displayName,
    title: title,
    faqs: faqs,
  };

  return FaqV2Props;
};
